export default "__VITE_ASSET__tUy91Wx2__"